import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';
import { getRecommendationsListPath } from '../routes';
import { CorrectionAdvicePage } from '@practium/features/recommendations';
import type { CorrectionFormData } from '@practium/features/recommendations';
import { usePermissions } from '@practium/features/permissions';
import { useForBinding } from '@practium/features/forBinding';
import {
	usePostAdviceCorrectionCreate,
	usePostAdviceCorrectionStart,
} from '@practium/features/api';
import { useToast } from '@practium/ui';

export const AddCorrectionAdvicePageClient = () => {
	const toast = useToast();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const adviceId = searchParams.get('id') || '';
	const { isForBinding } = useForBinding();
	const { abilities } = usePermissions();
	const subject = isForBinding ? 'farmers-recommendations' : 'recommendations';
	const { mutateAsync: createCorrectionAdvice } = usePostAdviceCorrectionCreate();
	const { mutateAsync: startCorrectionAdvice } = usePostAdviceCorrectionStart();

	const canCreate = abilities.can('create', subject);

	if (!canCreate) return <Navigate to="/recomendacoes" replace />;

	const handleStart = async (data: CorrectionFormData) => {
		let persistedAdviceId = adviceId;

		if (!persistedAdviceId) {
			try {
				const createdAdvice = await createCorrectionAdvice({
					...data,
					formasAplicacao: {},
				});
				persistedAdviceId = createdAdvice._id;
			} catch (error) {
				toast.error(
					error instanceof Error ? error.message : 'Erro ao criar a recomendação de correção.'
				);
				return;
			}
		}

		try {
			const startResult = await startCorrectionAdvice({
				adviceId: persistedAdviceId,
				prop: data.prop,
				area: data.area,
				sectors: data.sectors,
				soilAnalysis: data.soilAnalysis,
			});
			const workspaceId = startResult.adviceId || persistedAdviceId;
			navigate(`/recomendacoes/correcao/workspace?id=${workspaceId}`, {
				state: { correctionStart: startResult },
			});
		} catch (error) {
			toast.error(
				error instanceof Error ? error.message : 'Erro ao iniciar a recomendação de correção.'
			);
		}
	};

	return (
		<CorrectionAdvicePage
			onBack={() => navigate(getRecommendationsListPath('correction'))}
			onStart={handleStart}
		/>
	);
};
